import * as React from "react";

import { cn } from "@zyno/lib";

interface InputProps extends React.ComponentProps<"input"> {
  height?: number;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, disabled = false, height = 9, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          `flex h-${height} w-full rounded-md border border-input bg-transparent px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm`,
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
